  <div class="container">
    <div class="indexBox">
      <img src="assets/Element4.png" alt="face" class="responsive" />
      <h1 class="first-head">Hello, welcome to my page</h1>
      <p class="first-subhead">My name is Stefan and I currently work at <a href="https://bitfly.at">bitfly</a> as a developer.</p>
      <br />
    </div>
  </div>
